import { Component } from '@angular/core';
import { AppUpdateService } from '@shared/services/app-update/app-update.service';

@Component({
    selector: 'app-root',
    standalone: false,
    template: `
        <ng-bs-toast-service />
        <ng-bs-modal-service />
        <main>
            <router-outlet></router-outlet>
        </main>
    `,
    styleUrl: './app.component.css'
})
export class AppComponent {

    constructor(private readonly appUpdateService: AppUpdateService) {
        this.appUpdateService.initialize();
    }
}
